// @format
import React from 'react';
import styled from 'styled-components';
import Upper from './Upper';
import Lower from './Lower';

const LandingWrapper = styled.div`
  width: 100%;
  height: 100%;
  /* display: grid; */
  /* grid-template-rows: auto 40%; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 1100px) {
    display: block;
  }
`;

export default () => (
  <LandingWrapper>
    <Upper />
    <Lower />
  </LandingWrapper>
);
